import { post, get, put, deleteApi } from '../axiosFun'
import { fileDownload } from '../../utils/util'
/* 培训课程 */
// 分页
const annualPlanPage = (data) => {
    return post('/train/annual-training-plan/page', data)
}
// 列表
const annualPlanList = (data) => {
    return post('/train/annual-training-plan/list', data)
}
// 详情
const annualPlanDetail = (courseId) => {
    return get('/train/annual-training-plan/detail/' + courseId)
}
// 新增
const annualPlanAdd = (data) => {
    return post('/train/annual-training-plan/add', data)
}
// 编辑
const annualPlanEdit = (data) => {
    return put('/train/annual-training-plan/edit', data)
}
// 删除
const annualPlanRemove = (data) => {
    return deleteApi('/train/annual-training-plan/remove', data)
}
// 发布
const annualPlanPublish = (data) => {
    return post('/train/annual-training-plan/publish', data)
}
// 导入
const annualPlanImport = (data) => {
    return post('/train/annual-training-plan/import', data)
}
const annualPlanImportRes = (courseId) => {
    return get('/train/annual-training-plan/importRes')
}
const downloadTemplates = (courseId) => {
    return get('/static/templates/年度培训计划导入模版.xlsx')
}
// 获取部门
const deptList = (data) => {
    return get('/train/annual-training-plan/deptList', data)
}
const annualPlanExport = (data, header) => {
    return post('/train/annual-training-plan/exportExcel', data, header)
}
// 完成情况维护
const completed = (data, header) => {
    return put('/train/annual-training-plan/completed', data, header)
}
export default {
    annualPlanPage,
    annualPlanList,
    annualPlanDetail,
    annualPlanAdd,
    annualPlanEdit,
    annualPlanRemove,
    annualPlanPublish,
    annualPlanImport,
    annualPlanImportRes,
    downloadTemplates,
    deptList,
    annualPlanExport,
    completed,
}



// WEBPACK FOOTER //
// ./src/api/onlineTraining/annualPlan.js